module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-06.855b43e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-06.jpg
// module id = l81T
// module chunks = 1